const DEFAULT_IDLE_TIMEOUT_MS = 5_000;
const scheduleIdle = (task, timeoutMs) => {
    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => task(), { timeout: timeoutMs });
        return;
    }
    setTimeout(task, timeoutMs);
};
/** Runs `task` after the page has loaded and the main thread is idle, or after `timeoutMs`. */
export const runWhenIdle = (task, timeoutMs = DEFAULT_IDLE_TIMEOUT_MS) => {
    if (typeof window === 'undefined')
        return;
    if (document.readyState === 'complete') {
        scheduleIdle(task, timeoutMs);
        return;
    }
    window.addEventListener('load', () => scheduleIdle(task, timeoutMs), { once: true });
};
